export default __webpack_public_path__ + "static/media/not.e95115f3.jpg";